import {
    Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef
    //, ViewChild, ElementRef
} from '@angular/core';
import { DOData, DocdefDataVM, NJDocData, NJDocDefTemplate } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { style } from '@angular/animations';
//import * as $ from "jquery";

@Component({
    selector: 'cy-grid-ncheckbox',
    templateUrl: './grid-ncheckbox.component.html',
    styleUrls: ['./grid-ncheckbox.component.css']
})
export class GridNCheckboxComponent implements OnInit {
    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() lstChildDocDefTemplate: Array<NJDocDefTemplate>
    @Input() lstDocData: Array<NJDocData>
    @Input() customParameters: any
    lstChildCustomParameters: Array<any>;
    @Input() public ignorLabel: boolean = false;

    @Input() public loaderKey: string;
    @Input() isValid: boolean;
    @Input() isEnabled: boolean;
    public isDirty: boolean = false
    errorMessage: string;
    LabelStylesText: any
    StyleCell: any;
    private chkSelected: Array<any> = [];
    @Input() hasEvent: boolean = false;
    @Output() clickChkbox: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() checkboxAfterViewInit: EventEmitter<GridNCheckboxComponent> = new EventEmitter<GridNCheckboxComponent>();
    nCols: number = 4;
    nRows: number = 1;
    rows: Array<number> = new Array<number>();
    cols: Array<number> = new Array<number>();
    public labelBefore: boolean = false;
    public rowClass: string = "";
    public showLabel: boolean = false;
    imgLink: string = "";
    @Input() skipPostDocDefData: boolean;
    constructor(private data: DocDefPrimLibService, private changedata: ChangeDetectorRef) { }

    ngOnInit() {
        this.DocDefTemplate.dictCustomParameters = this.customParameters;
        if (this.customParameters['showLabel'] != null) {
            this.showLabel = this.customParameters['showLabel'].toLowerCase() == 'true';
        }
        if (this.customParameters['StyleCell'] != null) {
            let styles = this.data.replaceAll(this.customParameters['StyleCell'], "'", '"');
            this.StyleCell = JSON.parse(styles);
        }
        if (this.customParameters['LabelStylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['LabelStylesText'], "'", '"');
            this.LabelStylesText = JSON.parse(styles);
        }
        if (this.customParameters['NCols']) {
            this.nCols = +this.customParameters['NCols']
        }
        if (this.customParameters['rowClass']) {
            this.rowClass = this.customParameters['rowClass'];
        }
        if (this.customParameters['isEnabled']) {
            if (this.customParameters['isEnabled'] == 'False')
                this.isEnabled = false;
        }
        if (this.customParameters['imgLink']) {
            this.imgLink = this.customParameters['imgLink'];
        }

        if (this.DocDefTemplate.dictCustomParameters.hasEvent) {
            this.hasEvent = true;
        }
        this.setLabelPosition();
        for (let item of this.lstDocData) {

            let defaultChecked: Boolean = false;
            let templates: Array<NJDocDefTemplate>
                = this.lstChildDocDefTemplate.filter((d: NJDocDefTemplate) => { return ((d.dictCustomParameters["default"] == "checked" && d.docDefTemplateID == item.docDefTemplateID) && d.dictCustomParameters["default"]) });
            if (templates.length > 0)
                defaultChecked = true;
            else
                defaultChecked = false;

            if (defaultChecked)
                item.dataValue = "1";

            if (item.dataValue == "1")
                this.chkSelected.push(item.docDefTemplateID);

        }

        this.nRows = Math.floor((this.lstChildDocDefTemplate.length - 1) / this.nCols + 1);
        let i = 0; // 0,1,2,...this.nRows

        while (i < this.nRows) {
            this.rows.push(i);
            i++;
        }
        i = 0;
        while (i < this.nCols) {
            this.cols.push(i);
            i++;
        }

        this.setHiddenStatus();

        //      if (this.chkSelected.length > 0)
        //          this.doSaveAll();

    }
    isHidden: boolean;
    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        else
            this.isHidden = false;
    }

    labelClass(): string {
        if (this.customParameters['LabelWidth'] == null) {
            return "col-md-12 col-sm-12";
        } else {
            return this.customParameters['LabelWidth'];
        }
    }
    template(row: number, col: number): NJDocDefTemplate {
        let i = this.nCols * row + col;
        return this.lstChildDocDefTemplate[i];
    }
    templateIsDefined(row: number, col: number): boolean {
        let i = this.nCols * row + col;
        let isVisible: boolean = true;
        if (this.lstChildDocDefTemplate.length > i)
            if (this.lstChildDocDefTemplate[i].dictCustomParameters['isVisible'] != undefined) {
                if (this.lstChildDocDefTemplate[i].dictCustomParameters['isVisible'].toLowerCase() == "false") {
                    isVisible = false;
                }
            }
        return (this.lstChildDocDefTemplate.length > i) && isVisible;
    }
    //Purpose: to change the list of custom parameters in a GridNCheckboxComponent.
    // Input: strChgTemplateTemplateCode: Template code of template to be changed. If name is * change all children Checkboxes
    //        Name of custom parameter
    //        Value of custom parameter
    // Side effects. None
    // Process: Find template to be changed using strChgTemplateTemplateCode to select from list of template. 
    //          If strNameCustomParameter == "*" loop through all templates doing steps below.
    //          else if dictCustomParameters has the custom parameter in question
    //              Update custom paramenter         
    SetDoCompositeCustomParam(strChgTemplateTemplateCode: string, strNameCustomParameter: string, strValueCustomParameter: string) {
        if (strNameCustomParameter == "*") {
            for (let item of this.lstChildDocDefTemplate) {
                //if (item.dictCustomParameters[strNameCustomParameter]) {
                item.dictCustomParameters[strNameCustomParameter] = strValueCustomParameter;
                //}
            }
        } else {
            let templates = this.lstChildDocDefTemplate.filter(ldd => ldd.templateCode == strChgTemplateTemplateCode);
            if (templates.length > 0) {
                //if (templates[0].dictCustomParameters[strNameCustomParameter]) {
                templates[0].dictCustomParameters[strNameCustomParameter] = strValueCustomParameter;
                //}
            }
        }
    }
    IsSelected(docDefTemplateID: number): boolean {
        let ret: boolean = false;
        for (let DocData of this.lstDocData) {
            if (DocData.docDefTemplateID == docDefTemplateID && DocData.dataValue == '1') {
                ret = true;
                break;
            }
        }
        return ret;
    }
    selectedCheckBox(docDefTemplateID: number): boolean {
        let ret: boolean = false;
        for (let DocData of this.lstDocData) {
            if (DocData.docDefTemplateID == +docDefTemplateID) {
                DocData.dataValue = '1';

                let _index = this.lstDocData.findIndex(dd => dd.docDefTemplateID == +docDefTemplateID);

                this.chkSelected.splice(_index, 1);

                this.chkSelected.push(docDefTemplateID);

                this.doSave(_index);

                ret = true;
                break;
            }
        }
        return ret;
    }

    selectedCheckBoxGeneric(docDefTemplateID: number): boolean {
        //ALM#: 31917
        let ret: boolean = false;
        for (let DocData of this.lstDocData) {
            if (DocData.docDefTemplateID == +docDefTemplateID) {
                DocData.dataValue = '1';

                let _index = this.lstDocData.findIndex(dd => dd.docDefTemplateID == +docDefTemplateID);

                if (!this.chkSelected.includes(docDefTemplateID)) {
                    this.chkSelected.push(docDefTemplateID);
                }

                this.doSave(_index);

                ret = true;
                break;
            }
        }
        return ret;
    }
    unSelectedCheckBox(docDefTemplateID: number): boolean {
        let ret: boolean = false;
        for (let DocData of this.lstDocData) {
            if (DocData.docDefTemplateID == docDefTemplateID) {
                DocData.dataValue = '0';

                let _index = this.lstDocData.findIndex(dd => dd.docDefTemplateID == +docDefTemplateID);

                this.chkSelected.splice(_index, 1);

                this.doSave(_index);

                ret = true;
                break;
            }
        }
        return ret;
    }

    onBlurCheckbox() {
        //this.doSave();
    }

    clearCheckBoxes() {
        //this.refeshData();
        for (let DocData of this.lstDocData) {
            DocData.dataValue = '0';
        }
        this.doSaveAll();
    }
    selectCheckBoxes() {
        for (let DocData of this.lstDocData) {
            DocData.dataValue = '1';
        }
        this.doSaveAll();
    }

    doSaveAll() {
        let lstDocData: DocdefDataVM = new DocdefDataVM();
        lstDocData.docdata = this.lstDocData;
        lstDocData.loaderKey = this.loaderKey;
        var _this = this;
        this.data.saveDocDefData(lstDocData)
            .subscribe(function () {
            }, function (error) {
                return _this.errorMessage = error;
            });
    }


    doSave(ind: number) {
        this.isDirty = true;
        //Made this change to bypass the PostDocDefData calls in CyberANG PROJECT
        if ((this.customParameters.skipPostDocDefData == "True" || this.skipPostDocDefData == true) && this.customParameters.DontskipPostDocDefData != "True") {
            //return this.onSaveComplete();
            return this.onDoChkboxClick(ind);
        }
        else {
            if (!this.ignorLabel) {
                let lstDocData: DocdefDataVM = new DocdefDataVM();
                lstDocData.docdata = this.lstDocData;
                lstDocData.loaderKey = this.loaderKey;
                var _this = this;
                this.data.saveDocDefData(lstDocData)
                    .subscribe(function () {
                        return _this.onDoChkboxClick(ind);//_this.onSaveComplete();
                    }, function (error) {
                        return _this.errorMessage = error;
                    });
            }
        }
    }

    onSaveComplete = function () {
        
    }
    Class(template: NJDocDefTemplate) {
        let tempClass: string = "";
        if (template) {
            let dict = template.dictCustomParameters
            if (dict == undefined)
                dict = template.customParameters;
            if (dict['Class'] == null) {
                tempClass = "";
            } else {
                tempClass = dict['Class'] + " px-0";
            }

            return tempClass;
        } else {
            return "";
        }
    }
    getTextStyle(template: NJDocDefTemplate): object {
        let styles = {};
        if (!this.isValid)
            if (this.customParameters['LOCIValidate'] == null)
                styles = { "background-color": "lightpink" };
            else
                styles = { "background-color": "gainsboro" };
        //if this doesn't point to the GridNCheckBox as it's visual parent, go find it
        if (template.dictCustomParameters["CheckBoxVisualParent"] != null) {
            let level = 1;
            let newLevel = this.findParent(template.dictCustomParameters["CheckBoxVisualParent"], level);
            styles["margin-left"] = newLevel * 1.5 + "rem";
        }
        if (template.dictCustomParameters["BoldLabel"] != null) {
            styles["font-weight"] = "bold";
        }

        if (template.dictCustomParameters["margin-left"] != null) {
            styles["margin-left"] = template.dictCustomParameters["margin-left"];
        }
        return styles;
    }
    findParent(parentCode: string, level: number) {
        //find the template that matches the passed parentId
        let template = this.lstChildDocDefTemplate.find(x => x.templateCode == parentCode)
        //if the matching template is not a direct child 
        if (template != null && template.dictCustomParameters["CheckBoxVisualParent"] != null) {
            level++;
            level = this.findParent(template.dictCustomParameters["CheckBoxVisualParent"], level);
        }
        return level;

    }
    selectChk(event, val) {
        //ALM#: 31917
        if (event.target.checked && !this.chkSelected.includes(val)) {
            this.chkSelected.push(val);
        } else {
            if (this.chkSelected.includes(val)) {
                this.chkSelected.splice(this.chkSelected.indexOf(val), 1);
            }
        }
        for (let item of this.lstDocData) {
            var index = this.chkSelected.indexOf(item.docDefTemplateID);
            if (index >= 0)
                item.dataValue = '1';
            else
               item.dataValue = '0';
        }

        let _index = this.lstDocData.findIndex(dd => dd.docDefTemplateID == +val);
        this.doSave(_index);
    }
    setLabelPosition() {
        if (this.customParameters.labelBefore == 'Yes')
            this.labelBefore = true;
        else
            this.labelBefore = false;
    }
    onDoChkboxClick(index: number) {

        if (this.hasEvent) {
            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = this.lstDocData[index];
            DOMessage.njDocDefTemplate = this.lstChildDocDefTemplate.filter(ldd => ldd.docDefTemplateID == DOMessage.njDocData.docDefTemplateID)[0];
            this.clickChkbox.emit(DOMessage);

        }
    }

    getCheckBoxStyle(template: NJDocDefTemplate): string {
        let style = "";
        if (template.dictCustomParameters["CheckBoxStyle"] != null) {
            let styles = this.data.replaceAll(template.dictCustomParameters["CheckBoxStyle"], "'", '"');
            style = JSON.parse(styles);
        }
        return style;
    }
    ngAfterViewInit() {
        this.checkboxAfterViewInit.emit(this);
    }

    refeshData() {
        this.changedata.detectChanges();
    }
}